/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <News {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { News as NewsModule } from "@bw/modules"
import { useStaticQuery, graphql } from "gatsby"

const News = () => {
  const { news } = useStaticQuery(graphql`query newsModulesQuery {
  news: allCollectionNews(sort: {date: DESC}) {
    nodes {
      title
      slug
      date
      teaserExcerpt
      teaserImage {
        localImage {
          childImageSharp {
            gatsbyImageData(width: 350, height: 175)
          }
        }
      }
    }
  }
}`)

  if (!news.nodes) {
    return null
  }

  return <NewsModule news={news.nodes} />
}

export { News }
